import React, { useRef } from "react";
import "maplibre-gl/dist/maplibre-gl.css";
import { AddMap, AddLightpoints, FitBoundsPoints} from "../hooks/mapFunctions.js";

export default function MapLightpoint({ id, lightpoints }) {
  const mapContainer = useRef(null);
  const mapRef = AddMap(mapContainer);
  AddLightpoints(mapRef, lightpoints);
  FitBoundsPoints(mapRef, lightpoints);

  return (
    <div
      ref={mapContainer}
      style={{ width: "100%", height: "400px", borderRadius: "12px", overflow: "hidden" }}
    />
  );
}
  

